import React, { FunctionComponent, PropsWithChildren } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { WithTranslation } from '@modules/translate/types/withTranslation';
import dynamic from 'next/dynamic';
import moment from "moment/moment";
const SeoEditComponent = dynamic(() => import('@components/SeoEditComponent'), { ssr: false });

const AuthLayout: FunctionComponent<PropsWithChildren<WithTranslation>> = (props) => {
  const { children, translate } = props;
  const router = useRouter();
  const isSignIn = router.pathname == '/auth/sign-in';
  const isSignUp = router.pathname == '/auth/sign-up';
  //TODO: redirect fixed

  return (
    <>
      <SeoEditComponent />
      <div className="greeter-container">
        <div className="auth-container">
          <Link href="/">
            <a className="auth-header">
              <img src={`/landing/svg/${translate('logo_dark')}.svg`} alt="langco" className="auth-header__logo" />
            </a>
          </Link>
          <div className="auth-body">
            <div className="sing-forms">
              {(isSignIn || isSignUp) && (
                <div className="sing-switcher">
                  <div
                    className={`sing-switcher__element ${isSignIn && 'active' || ''}`}
                    onClick={() => router.push('/auth/sign-in')}
                  >{translate('singIn')}</div>
                  <div
                    className={`sing-switcher__element ${isSignUp && 'active' || ''}`}
                    onClick={() => router.push('/auth/sign-up')}
                  >{translate('singUp')}</div>
                </div>
              )}
              {children}
            </div>
          </div>
        </div>
        <div className="welcome-container">
          <div className="welcome-container__head">
            <h1 className="welcome-container__title">{translate('welcomeTitle')}</h1>
            <h2 className="welcome-container__subtitle">{translate('welcomeSubTitle')}</h2>
          </div>
          <div className="welcome-container__bg">
            <img className="welcome-bg-1" src="/svg/welcome-bg-1.svg" alt="welcome-bg" />
            <img className="welcome-bg-1" src="/svg/welcome-bg-2.svg" alt="welcome-bg" />
            <img className="welcome-bg-1" src="/img/welcome-bg-3.png" alt="welcome-bg" />
            <img className="welcome-bg-1" src="/svg/welcome-bg-4.svg" alt="welcome-bg" />
          </div>
          <div className="welcome-container__copyright">
            © {translate('site-title')}, {moment().format('YYYY')}
          </div>
        </div>
      </div>
    </>
  );
};


export default AuthLayout;
